module.exports = __webpack_public_path__ + "img/loading.20339924.gif";